
import axios from '@/common/js/request'
// 查看工作轨迹
export function pageWorktrackRecord(params){  
    const pageWorktrackRecord = axios({
        url: '/disTrackWork/pageWorktrackRecord',
        method: 'get',
        params
    })
    return pageWorktrackRecord
}
export function listWorktrackByRecordId(params){  
  const listWorktrackByRecordId = axios({
      url: '/disTrackWork/listWorktrackByRecordId',
      method: 'get',
      params
  })
  return listWorktrackByRecordId
}